import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios'; // <-- IMPORT STANDARD AXIOS, NOT YOUR CUSTOM ONE

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('Verifying your email...');

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('Invalid link: No verification token found.');
            return;
        }

        // Use raw axios to prevent the interceptor from attaching an old JWT token
        // Based on your authService baseURL ('/'), this relative path should hit your proxy correctly
        axios.get(`/auth/verify-email?token=${token}`)
            .then(response => {
                setStatus('Email verified successfully! Redirecting to login...');
                setTimeout(() => navigate('/login'), 2000);
            })
            .catch(error => {
                console.error("Verification failed:", error);
                setStatus(error.response?.data || 'Email verification failed.');
            });

    }, [searchParams, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: 'var(--lp-dark, #0e1117)' }}>
            <div style={{ background: 'var(--lp-surface, #161b27)', padding: '2rem', borderRadius: '16px', color: 'white', textAlign: 'center' }}>
                <h2>Email Verification</h2>
                <p>{status}</p>
            </div>
        </div>
    );
};

export default VerifyEmailPage;